import React, { useEffect, useState, useCallback } from "react";
import Table from "../../../../common/element/Table";
import Tag from "../../../../common/element/Tag";
import { useSelector } from "react-redux";
import Tooltip from "../../../../common/element/Tooltip";
import Dialog from "../../../../common/element/Dialog/Dialog";
import Tabs from "../../../../common/element/Tabs";
import Documents from "./Documents";
import { DashboardClientCompanyInductions } from "../../../../actions/Admin-Client/AllOverviewApi";
import { useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import ClientDetails from "./ClientDetails";
import Scrollbar from "../../../../common/element/ScrollBar";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import Button from "../../../../common/element/Buttons";
import { updateRoutefunc } from "../../../../redux/classes/common/updateRoute";
import Inductions from "./SiteInduction";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import { reject } from "lodash";
import moment from "moment";
import CompanyInductions from "./CompanyInducton";
import PdfDataView from "../../../../common/pdfView/Index";
import { GetProviderOtherDetails } from "../../../../actions/admin-worker/GetProviderOtherDetails";
const { TabNav, TabList, TabContent } = Tabs;
const ClientsList = (props) => {
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [clientDataName, setClientDataName] = useState([]);
  const [editBtnHide, setEditBtnHide] = useState(true);
  const [clientData, setClientData] = useState(null);
  const [pdfData, setPdfData] = useState("");
  const [clientOrgId, setClientOrgId] = useState("");
  const [indivisualData, setIndivisualData] = useState(null);
  const { Tr, Th, Td, THead, TBody } = Table;

  useEffect(() => {
    if (props?.allClientsAssign) {
      setClientData(props?.allClientsAssign);
    }
  }, [props?.allClientsAssign]);
  const UpdateRoute = () => {
    dispatch(updateRoutefunc(true));
  };
  const [dialogIsOpen, setIsOpen] = useState(false);

  const openDialog = (item) => {
    setIndivisualData(item);
    setIsOpen(true);
  };

  const onDialogClose = (e) => {
    setIsOpen(false);
    setClientOrgId("");
  };

  const onDialogOk = (e) => {
    setIsOpen(false);
  };
  // const fetchClientCompanyInductions = useCallback(async (function_assignment_id) => {
  //   try {
  //     const response = await dispatch(DashboardClientCompanyInductions(function_assignment_id));
  //     if (response.success) {
  //       const arrayData = response?.data;
  //       setClientDataName(arrayData);
  //       setEditBtnHide(true)
  //     } else if (response?.status === 401) {
  //       handleUnauthorizedAccess();
  //     } else {
  //       // Handle other errors
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }, [dispatch]);

  // useEffect(() => {
  //   // if () {
  //     fetchClientCompanyInductions("fd91be60-d246-413f-825e-aba18dbb3f6a");
  //   // }
  // }, []);
  useEffect(() => {
    let payload = { provider_org_id: props?.selectedProvType?.organisation_id };
    if (props?.selectedProvType?.organisation_id && dialogIsOpen) {
      dispatch(GetProviderOtherDetails(payload, "worker")).then((response) => {
        if (response.success) {
          let resData = response.data;
          setPdfData({
            email: resData?.email,
            last_certificate_gen_date: resData?.last_certificate_gen_date,
            phone: resData?.phone,
            abn_nzbn: resData?.abn_nzbn,
            acn: resData?.acn,
            org_fax: resData?.org_fax,
            provider_fa_id: props?.selectedProvType?.provider_fa_id,
            organisation_id: props?.selectedProvType?.organisation_id,
            trading_name: resData?.trading_name,
            address_one:
              resData?.provAddressData[0]?.address_one +
              " " +
              resData?.provAddressData[0]?.zipcode,
          });
        }
      });
    }
  }, [props?.selectedProvType?.organisation_id, dialogIsOpen]);

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th className="w-80">
                <span
                  className="flex items-center gap-1"
                  onClick={() => props.handleSort("trading_name")}
                >
                  Client name
                  <svg
                    className={`transform ${
                      props?.getAllinvitedData.sort !== "" &&
                      props?.getAllinvitedData.sort === "trading_name" &&
                      props?.getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th className="w-80">
                <span className="flex items-center gap-1">Email</span>
              </Th>
              <Th className="w-60">
                <span className="flex items-center gap-1">Phone number</span>
              </Th>
              <Th className="w-60">
                <span
                  className="flex items-center gap-1"
                  // onClick={() => props?.handleSort("trading_name")}
                >
                  Assigned
                  <svg
                    className={`transform ${
                      props?.getAllinvitedData.sort !== "" &&
                      props?.getAllinvitedData.sort === "" &&
                      props?.getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th className="w-60">Status</Th>
              <Th>Card</Th>
            </Tr>
          </THead>
          <TBody>
            {props?.loadData &&
              clientData?.map((item, index) => {
                let status;
                // let assigned;
                const approvalStatusArray = item?.orgChklists?.flatMap((item) =>
                  item?.compDocs
                    ?.filter((doc) => doc)
                    ?.map((doc) =>
                      doc.DocAppr !== null
                        ? doc.DocAppr.approval_status
                        : "pending"
                    )
                );

                const assignedStatusArray = item?.orgChklists?.flatMap((item) =>
                  item?.compDocs
                    ?.filter((doc) => doc)
                    ?.map((doc) =>
                      doc.DocAppr !== null
                        ? doc.DocAppr.approval_status
                        : "null"
                    )
                );

                const reviewed_date = item?.orgChklists?.flatMap((item) =>
                  item?.compDocs
                    ?.filter((doc) =>
                      doc?.DocAppr?.reviewed_date
                        ? doc.DocAppr?.reviewed_date !== "null" &&
                          doc?.DocAppr?.reviewed_date !== null
                        : ""
                    )
                    ?.map(
                      (doc) =>
                        doc.DocAppr !== null &&
                        doc.DocAppr !== "null" &&
                        doc.DocAppr.reviewed_date
                    )
                );
                if (approvalStatusArray?.includes("client_approval_req")) {
                  status = "Action required";
                } else if (
                  approvalStatusArray?.length == 2 &&
                  approvalStatusArray?.includes("approved") &&
                  approvalStatusArray?.includes("client_approved_action")
                ) {
                  status = "Approved";
                } else if (
                  approvalStatusArray?.every(
                    (status) => status === "admin_approved"
                  )
                ) {
                  status = "Approved";
                } else if (
                  approvalStatusArray?.every(
                    (status) => status === "client_approved"
                  )
                ) {
                  status = "Approved";
                } else if (
                  approvalStatusArray?.every((status) => status === "approved")
                ) {
                  status = "Approved";
                } else if (
                  approvalStatusArray?.every(
                    (status) => status === "client_approved_action"
                  )
                ) {
                  status = "Approved";
                } else if (approvalStatusArray?.includes("admin_reject")) {
                  status = "Action required";
                } else if (approvalStatusArray?.includes("client_reject")) {
                  status = "Action required";
                } else if (
                  approvalStatusArray?.every((status) => status === "pending")
                ) {
                  status = "Awaiting review";
                } else if (
                  approvalStatusArray?.every((status) => status === null)
                ) {
                  status = "Awaiting review";
                } else {
                  status = "Action required";
                }
                return (
                  <Tr
                    key={index}
                    onClick={() => {
                      setClientOrgId(item?.client_org_id);
                      openDialog(item);
                    }}
                  >
                    <Td>{item?.trading_name ? item?.trading_name : "-"}</Td>
                    <Td>{item?.contact_email}</Td>
                    <Td>
                      <div className="flex mb-4">
                        <div className="flex-1">
                          <span className="text-gray-900 font-medium block text-sm">
                            {item?.contact_phone ? item?.contact_phone : "-"}
                          </span>
                          <span className="text-gray-400 font-semibold block text-sm mb-1">
                            {`${
                              item?.contact_first_name
                                ? item?.contact_first_name
                                : "-"
                            } ${
                              item?.contact_last_name
                                ? item?.contact_last_name
                                : ""
                            }`}
                          </span>
                        </div>
                      </div>
                    </Td>
                    <Td>
                      {item?.created_date
                        ? moment(item?.created_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>

                    <Td>
                      <Tag
                        className={`${
                          item?.status?.toLowerCase() === "compliant"
                            ? "tag text-success-700 bg-success-50"
                            : "text-error-700 bg-error-50"
                        }`}
                      >
                      {item?.status?.toLowerCase() === "compliant" ? "Compliant" :"Non-Compliant"}
                      </Tag>
                    </Td>
                    <Td>
                      <Button className="flex justify-center">
                        {/* <Tag
                        className={`${status == "Action required"
                          ? "badge-wrapper bg-error-100 text-error-700"
                          : status ==
                            "badge-wrapper bg-blue-100 text-blue-700"
                            ? "badge-wrapper bg-blue-100 text-blue-700"
                            : "text-success-700 bg-success-50"
                          }`}
                      >
                        {status}
                      </Tag> */}
                        {/* {item?.docs_status?.toLowerCase() === "compliant" ? ( */}
                        <span
                          onClick={() => {
                            setClientOrgId(item?.client_org_id);
                            openDialog(item);
                          }}
                        >
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M24.4243 27.8659H15.5756C14.6268 27.8659 13.855 27.0941 13.855 26.1453V13.8554C13.855 12.9066 14.6268 12.1348 15.5756 12.1348H24.4245C25.3732 12.1348 26.1451 12.9066 26.1451 13.8554V26.1453C26.1451 27.0941 25.3731 27.8659 24.4243 27.8659ZM24.6701 13.8551C24.6701 13.7194 24.5595 13.6093 24.4243 13.6093H15.5756C15.4404 13.6093 15.3298 13.7194 15.3298 13.8551C15.3298 26.7084 15.1926 26.3909 15.5755 26.3909C24.6903 26.3909 24.6701 26.5472 24.6701 26.1451L24.6701 13.8551Z"
                              fill="#344054"
                            />
                            <path
                              d="M21.2287 15.8218H18.7707C18.3637 15.8218 18.0333 15.4919 18.0333 15.0844C18.0333 14.6769 18.3637 14.347 18.7707 14.347H21.2287C21.6358 14.347 21.9661 14.6769 21.9661 15.0844C21.9661 15.4919 21.6358 15.8218 21.2287 15.8218Z"
                              fill="#344054"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M19.9999 17.9738C19.2865 17.9738 18.7082 18.5521 18.7082 19.2655C18.7082 19.9788 19.2865 20.5571 19.9999 20.5571C20.7132 20.5571 21.2915 19.9788 21.2915 19.2655C21.2915 18.5521 20.7132 17.9738 19.9999 17.9738ZM17.5415 19.2655C17.5415 17.9078 18.6422 16.8071 19.9999 16.8071C21.3576 16.8071 22.4582 17.9078 22.4582 19.2655C22.4582 20.6232 21.3576 21.7238 19.9999 21.7238C18.6422 21.7238 17.5415 20.6232 17.5415 19.2655ZM17.2702 24.3071H22.7295C22.0842 23.491 21.0998 22.9738 19.9999 22.9738C18.8999 22.9738 17.9156 23.491 17.2702 24.3071ZM16.2911 23.6663C17.1429 22.539 18.4859 21.8071 19.9999 21.8071C21.5138 21.8071 22.8569 22.539 23.7086 23.6663C23.713 23.672 23.7173 23.6778 23.7218 23.6837C23.7905 23.7745 23.8729 23.8834 23.9329 23.9905C24.0087 24.1258 24.0689 24.2903 24.0653 24.4921C24.0623 24.6551 24.0133 24.8035 23.9566 24.9174C23.8999 25.0313 23.8111 25.1598 23.6828 25.2605C23.511 25.3953 23.3263 25.4404 23.1753 25.4585C23.0471 25.4739 22.8981 25.4739 22.7615 25.4738C22.7538 25.4738 22.7461 25.4738 22.7385 25.4738H17.2612C17.2536 25.4738 17.2459 25.4738 17.2382 25.4738C17.1016 25.4739 16.9526 25.4739 16.8244 25.4585C16.6734 25.4404 16.4888 25.3953 16.317 25.2605C16.1887 25.1598 16.0999 25.0313 16.0431 24.9174C15.9864 24.8035 15.9375 24.6551 15.9345 24.4921C15.9308 24.2903 15.991 24.1258 16.0669 23.9905C16.1268 23.8834 16.2092 23.7745 16.2779 23.6837C16.2824 23.6778 16.2868 23.672 16.2911 23.6663Z"
                              fill="#344054"
                            />
                            <path
                              d="M22.7295 24.3071V24.4071C22.7678 24.4071 22.8028 24.3852 22.8195 24.3507C22.8362 24.3162 22.8317 24.2752 22.8079 24.2451L22.7295 24.3071ZM17.2702 24.3071L17.1918 24.2451C17.168 24.2752 17.1635 24.3162 17.1802 24.3507C17.1969 24.3852 17.2319 24.4071 17.2702 24.4071V24.3071ZM16.2911 23.6663L16.2113 23.606L16.2113 23.606L16.2911 23.6663ZM23.7086 23.6663L23.6288 23.7266L23.6288 23.7266L23.7086 23.6663ZM23.7218 23.6837L23.642 23.744L23.642 23.744L23.7218 23.6837ZM23.9329 23.9905L24.0201 23.9416V23.9416L23.9329 23.9905ZM24.0653 24.4921L23.9653 24.4903V24.4903L24.0653 24.4921ZM23.9566 24.9174L23.8671 24.8728L23.9566 24.9174ZM23.6828 25.2605L23.7445 25.3392H23.7445L23.6828 25.2605ZM23.1753 25.4585L23.1634 25.3592L23.1753 25.4585ZM22.7615 25.4738L22.7615 25.5738H22.7615L22.7615 25.4738ZM17.2382 25.4738L17.2383 25.5738H17.2383L17.2382 25.4738ZM16.8244 25.4585L16.8364 25.3592H16.8364L16.8244 25.4585ZM16.317 25.2605L16.3787 25.1818H16.3787L16.317 25.2605ZM16.0431 24.9174L15.9536 24.962L16.0431 24.9174ZM15.9345 24.4921L16.0345 24.4903L15.9345 24.4921ZM16.0669 23.9905L16.1541 24.0394L16.1541 24.0394L16.0669 23.9905ZM16.2779 23.6837L16.1982 23.6234L16.1982 23.6234L16.2779 23.6837ZM18.8082 19.2655C18.8082 18.6073 19.3417 18.0738 19.9999 18.0738V17.8738C19.2313 17.8738 18.6082 18.4969 18.6082 19.2655H18.8082ZM19.9999 20.4571C19.3417 20.4571 18.8082 19.9236 18.8082 19.2655H18.6082C18.6082 20.0341 19.2313 20.6571 19.9999 20.6571V20.4571ZM21.1915 19.2655C21.1915 19.9236 20.658 20.4571 19.9999 20.4571V20.6571C20.7685 20.6571 21.3915 20.0341 21.3915 19.2655H21.1915ZM19.9999 18.0738C20.658 18.0738 21.1915 18.6073 21.1915 19.2655H21.3915C21.3915 18.4969 20.7685 17.8738 19.9999 17.8738V18.0738ZM19.9999 16.7071C18.5869 16.7071 17.4415 17.8525 17.4415 19.2655H17.6415C17.6415 17.963 18.6974 16.9071 19.9999 16.9071V16.7071ZM22.5582 19.2655C22.5582 17.8525 21.4128 16.7071 19.9999 16.7071V16.9071C21.3023 16.9071 22.3582 17.963 22.3582 19.2655H22.5582ZM19.9999 21.8238C21.4128 21.8238 22.5582 20.6784 22.5582 19.2655H22.3582C22.3582 20.5679 21.3023 21.6238 19.9999 21.6238V21.8238ZM17.4415 19.2655C17.4415 20.6784 18.5869 21.8238 19.9999 21.8238V21.6238C18.6974 21.6238 17.6415 20.5679 17.6415 19.2655H17.4415ZM22.7295 24.2071H17.2702V24.4071H22.7295V24.2071ZM19.9999 23.0738C21.0676 23.0738 22.0237 23.5756 22.6511 24.3692L22.8079 24.2451C22.1447 23.4063 21.1321 22.8738 19.9999 22.8738V23.0738ZM17.3487 24.3692C17.9761 23.5756 18.9322 23.0738 19.9999 23.0738V22.8738C18.8677 22.8738 17.855 23.4063 17.1918 24.2451L17.3487 24.3692ZM19.9999 21.7071C18.4528 21.7071 17.0809 22.4552 16.2113 23.606L16.3709 23.7266C17.2049 22.6229 18.519 21.9071 19.9999 21.9071V21.7071ZM23.7884 23.606C22.9188 22.4552 21.547 21.7071 19.9999 21.7071V21.9071C21.4807 21.9071 22.7949 22.6229 23.6288 23.7266L23.7884 23.606ZM23.8015 23.6233C23.7971 23.6175 23.7927 23.6117 23.7884 23.606L23.6288 23.7266C23.6332 23.7323 23.6376 23.7382 23.642 23.744L23.8015 23.6233ZM24.0201 23.9416C23.9562 23.8275 23.8694 23.713 23.8015 23.6233L23.642 23.744C23.7116 23.836 23.7896 23.9393 23.8456 24.0394L24.0201 23.9416ZM24.1652 24.4939C24.1693 24.2699 24.1021 24.0879 24.0201 23.9416L23.8456 24.0394C23.9153 24.1638 23.9686 24.3108 23.9653 24.4903L24.1652 24.4939ZM24.0461 24.962C24.1076 24.8384 24.1619 24.6754 24.1652 24.4939L23.9653 24.4903C23.9626 24.6349 23.919 24.7685 23.8671 24.8728L24.0461 24.962ZM23.7445 25.3392C23.8873 25.2271 23.9846 25.0855 24.0461 24.962L23.8671 24.8728C23.8152 24.9771 23.7348 25.0925 23.621 25.1818L23.7445 25.3392ZM23.1872 25.5578C23.3482 25.5385 23.5529 25.4895 23.7445 25.3392L23.621 25.1818C23.469 25.3011 23.3044 25.3423 23.1634 25.3592L23.1872 25.5578ZM22.7615 25.5738C22.8965 25.5739 23.0519 25.574 23.1872 25.5578L23.1634 25.3592C23.0423 25.3738 22.8997 25.3739 22.7615 25.3738L22.7615 25.5738ZM22.7385 25.5738C22.7461 25.5738 22.7538 25.5738 22.7615 25.5738L22.7616 25.3738C22.7539 25.3738 22.7462 25.3738 22.7385 25.3738V25.5738ZM17.2612 25.5738H22.7385V25.3738H17.2612V25.5738ZM17.2383 25.5738C17.246 25.5738 17.2536 25.5738 17.2612 25.5738V25.3738C17.2536 25.3738 17.2459 25.3738 17.2382 25.3738L17.2383 25.5738ZM16.8125 25.5578C16.9478 25.574 17.1032 25.5739 17.2383 25.5738L17.2382 25.3738C17.1001 25.3739 16.9574 25.3738 16.8364 25.3592L16.8125 25.5578ZM16.2552 25.3392C16.4468 25.4895 16.6516 25.5385 16.8125 25.5578L16.8364 25.3592C16.6953 25.3423 16.5307 25.3011 16.3787 25.1818L16.2552 25.3392ZM15.9536 24.962C16.0151 25.0855 16.1124 25.2271 16.2552 25.3392L16.3787 25.1818C16.2649 25.0925 16.1846 24.9771 16.1327 24.8728L15.9536 24.962ZM15.8345 24.4939C15.8378 24.6754 15.8921 24.8384 15.9536 24.962L16.1327 24.8728C16.0807 24.7685 16.0371 24.6349 16.0345 24.4903L15.8345 24.4939ZM15.9796 23.9416C15.8977 24.0879 15.8304 24.2699 15.8345 24.4939L16.0345 24.4903C16.0312 24.3108 16.0844 24.1638 16.1541 24.0394L15.9796 23.9416ZM16.1982 23.6234C16.1303 23.713 16.0436 23.8275 15.9796 23.9416L16.1541 24.0394C16.2101 23.9393 16.2881 23.836 16.3577 23.744L16.1982 23.6234ZM16.2113 23.606C16.207 23.6117 16.2027 23.6175 16.1982 23.6234L16.3577 23.744C16.3621 23.7382 16.3665 23.7323 16.3709 23.7266L16.2113 23.606Z"
                              fill="#344054"
                            />
                          </svg>
                        </span>
                        {/* ) : null} */}
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>

      <Dialog
        isOpen={dialogIsOpen}
        onClose={onDialogClose}
        onRequestClose={onDialogClose}
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.818 7.48905L20.818 7.48906C21.2151 7.55537 21.5063 7.89888 21.5063 8.30132V21.3249C21.5063 21.7796 21.1378 22.1484 20.6828 22.1484H14.8945C14.4399 22.1484 14.0711 21.7793 14.0711 21.3249C14.0711 20.8704 14.4399 20.5013 14.8945 20.5013H19.8595L19.8594 8.99906L12.8239 7.82655V21.3249C12.8239 21.7793 12.4552 22.1484 12.0004 22.1484C11.5458 22.1484 11.1771 21.7793 11.1771 21.3249V6.85434C11.1771 6.61219 11.2835 6.38252 11.4682 6.22611C11.6528 6.06957 11.8972 6.00228 12.1357 6.04206C12.1357 6.04206 12.1357 6.04206 12.1357 6.04206L20.818 7.48905Z"
                fill="#344054"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0706 17.7071C14.0706 17.2521 14.4391 16.8836 14.894 16.8836H17.7882C18.2432 16.8836 18.6117 17.2521 18.6117 17.7071V21.3247C18.6117 21.7796 18.2432 22.1483 17.7882 22.1483H14.894C14.4391 22.1483 14.0706 21.7796 14.0706 21.3247V17.7071ZM15.7176 20.5012H16.9647V18.5306H15.7176V20.5012Z"
                fill="#344054"
                stroke="#344054"
                stroke-width="0.2"
              />
              <path
                d="M5.39091 17.7071C5.39091 17.2521 5.75953 16.8836 6.21446 16.8836H9.1086C9.56355 16.8836 9.93203 17.2521 9.93203 17.7071V21.3247C9.93203 21.7796 9.56357 22.1483 9.1086 22.1483H6.21446C5.75951 22.1483 5.39091 21.7797 5.39091 21.3247V17.7071ZM7.03805 20.5012H8.28504V18.5306H7.03805V20.5012Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M3.45215 3.14766L3.45226 3.14768L12.1345 4.59492C12.5315 4.6611 12.8227 5.00451 12.8227 5.40719V21.3247C12.8227 21.7795 12.4543 22.1481 11.9992 22.1481H6.21095C5.75633 22.1481 5.38764 21.779 5.38764 21.3247C5.38764 20.8704 5.75633 20.5013 6.21095 20.5013H11.1759L11.1759 6.10492L4.14038 4.93217V21.3248C4.14038 21.7791 3.7717 22.1482 3.31707 22.1482C2.86233 22.1482 2.49364 21.7791 2.49364 21.3248V3.95996C2.49364 3.71782 2.6002 3.48843 2.78471 3.33197C2.9694 3.17512 3.21377 3.10819 3.45215 3.14766Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M16.9647 13.7278C16.9647 13.4728 17.1715 13.266 17.4264 13.266H18.1499C18.4049 13.266 18.6117 13.4728 18.6117 13.7278V14.4513C18.6117 14.7061 18.4049 14.9131 18.1499 14.9131H17.4264C17.1715 14.9131 16.9647 14.7061 16.9647 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0702 13.7278C14.0702 13.4728 14.277 13.266 14.532 13.266H15.2554C15.5104 13.266 15.7172 13.4728 15.7172 13.7278V14.4513C15.7172 14.7061 15.5104 14.9131 15.2554 14.9131H14.532C14.277 14.9131 14.0702 14.7062 14.0702 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0702 10.8335C14.0702 10.5787 14.277 10.3717 14.532 10.3717H15.2554C15.5104 10.3717 15.7172 10.5786 15.7172 10.8335V11.557C15.7172 11.8119 15.5104 12.0188 15.2554 12.0188H14.532C14.277 12.0188 14.0702 11.8119 14.0702 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M16.9647 10.8335C16.9647 10.5787 17.1715 10.3717 17.4264 10.3717H18.1499C18.4049 10.3717 18.6117 10.5786 18.6117 10.8335V11.557C18.6117 11.8119 18.4049 12.0188 18.1499 12.0188H17.4264C17.1715 12.0188 16.9647 11.8118 16.9647 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 13.7278C8.28501 13.4728 8.49182 13.266 8.7468 13.266H9.47036C9.72523 13.266 9.93203 13.4728 9.93203 13.7278V14.4513C9.93203 14.7061 9.72526 14.9131 9.47036 14.9131H8.7468C8.49182 14.9131 8.28501 14.7062 8.28501 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 13.7278C5.39036 13.4728 5.59717 13.266 5.85215 13.266H6.57571C6.83053 13.266 7.0375 13.4728 7.0375 13.7278V14.4513C7.0375 14.7062 6.83057 14.9131 6.57571 14.9131H5.85215C5.59716 14.9131 5.39036 14.7062 5.39036 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 10.8335C5.39036 10.5787 5.59715 10.3717 5.85215 10.3717H6.57571C6.83055 10.3717 7.0375 10.5786 7.0375 10.8335V11.557C7.0375 11.8119 6.83057 12.0188 6.57571 12.0188H5.85215C5.59716 12.0188 5.39036 11.8119 5.39036 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 10.8335C8.28501 10.5787 8.4918 10.3717 8.7468 10.3717H9.47036C9.72525 10.3717 9.93203 10.5787 9.93203 10.8335V11.557C9.93203 11.8118 9.72526 12.0188 9.47036 12.0188H8.7468C8.49182 12.0188 8.28501 11.8119 8.28501 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 7.93943C8.28501 7.68461 8.4918 7.47764 8.7468 7.47764H9.47036C9.72525 7.47764 9.93203 7.68461 9.93203 7.93943V8.66299C9.93203 8.91793 9.72524 9.12478 9.47036 9.12478H8.7468C8.49184 9.12478 8.28501 8.91797 8.28501 8.66299V7.93943Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 7.93943C5.39036 7.68461 5.59715 7.47764 5.85215 7.47764H6.57571C6.83055 7.47764 7.0375 7.68457 7.0375 7.93943V8.66299C7.0375 8.91797 6.83055 9.12478 6.57571 9.12478H5.85215C5.59718 9.12478 5.39036 8.91797 5.39036 8.66299V7.93943Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
            </svg>
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              Viewing Client
            </h5>
          </div>
        </div>
        <div className="px-4 pb-4">
          <Tabs defaultValue="tab1" variant="pill">
            <div className=" bg-blue-25 border border-gray-100 p-1 rounded-lg mb-5">
              <TabList>
                <TabNav value="tab1" className="flex-1">
                  Documents
                </TabNav>
                <TabNav value="tab2" className="flex-1">
                  Client Details
                </TabNav>
                <TabNav value="tab3" className="flex-1">
                  Company Induction
                </TabNav>
                <TabNav value="tab5" className="flex-1">
                  Site Induction
                </TabNav>

                <TabNav value="tab4" className="flex-1">
                 Worker Card
                </TabNav>
              </TabList>
            </div>
            <TabContent value="tab1" className="px-0">
              <div className="h-64 overflow-auto">
                <Scrollbar>
                  <Documents
                    onDialogClose={onDialogClose}
                    indivisualData={indivisualData}
                    getAllinvitedData={props.getAllinvitedData}
                    handleSort={props.handleSort}
                    selectedProvType={props?.selectedProvType}
                    clientOrgId={clientOrgId}
                  />
                </Scrollbar>
              </div>
            </TabContent>
            <TabContent value="tab2">
              <ClientDetails
                clientOrgId={clientOrgId}
                selectedProvType={props?.selectedProvType}
              />
            </TabContent>

            <TabContent value="tab3">
              <CompanyInductions
                clientOrgId={clientOrgId}
                selectedProvType={props?.selectedProvType}
              />
            </TabContent>

            <TabContent value="tab5">
              <Inductions
                clientOrgId={clientOrgId}
                selectedProvType={props?.selectedProvType}
              />
            </TabContent>
            <TabContent value="tab4">
              <PdfDataView
                type="worker"
                provider_org_id={props?.selectedProvType?.organisation_id}
              />
            </TabContent>
          </Tabs>
        </div>
        <div className="flex dailog-footer justify-end gap-2">
          <BtnLight
            className="ltr:mr-2 rtl:ml-2 w-40	"
            variant="plain"
            onClick={onDialogClose}
          >
            Close
          </BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};
export default ClientsList;
